import React from 'react';
import Header from '../Sheared/Header/Header';

const Notfound = () => {

    return (
        <div>
            <Header color="black" />
            <h1 className='text-danger text-center'>PAGE NON FOUND</h1>
        </div>
    );
};

export default Notfound;